// extracted by mini-css-extract-plugin
module.exports = {"gameHeader":"GameHeader__gameHeader__37Ds3","global":"GameHeader__global__3a-5W","content":"GameHeader__content__1B5O2"};